<template>
  <app-icon
    :size="16"
    class="verified-icon"
    name="verified"/>
</template>

<style>
.verified-icon {
  color: var(--color-success);
}
</style>
